import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { ChancenwerkUser } from '../../master-data-management/users/entities/ChancenwerkUser.js';

/**
 * @entity ChancenPersonalConfig
 */
@Entity()
export class ChancenPersonalConfig extends MongoEntity {
  public static override _class = 'ChancenPersonalConfig';
  public static override _collectionName = 'personal-configs';

  @validate(nonOptional())
  @Field(() => String)
  public userID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ userID }) => userID)
  user: Maybe<ChancenwerkUser>;

  /**
   * A user specified key. Could be anything but needs to be unique per category
   */
  @validate(nonOptional())
  @Field(() => String)
  public key: Maybe<string>;

  /**
   * the category of the config. Like list-person or list-partners
   * This enables us to save more than one config per page
   */
  @validate(nonOptional())
  @Field(() => String)
  public category: Maybe<string>;

  public static getDefault(category: string, key: string): ChancenPersonalConfig | undefined {
    throw new Error('Tried to call default on abstract class');
  }
}
